export const sexCheck = (sex = true) => {
  let result = "남자";
  if (sex) {
    result = "남성";
  } else {
    result = "여성";
  }
  return result;
};

export const dmynCheck = (dmyn = false) => {
  let result = "없음";
  if (dmyn) {
    result = "있음";
  }
  return result;
};
export const pyeCheck = (pye = false) => {
  let result = "없음";
  if (pye) {
    result = "만성폐쇄성폐질환 있음";
  }
  return result;
};
export const tbsickCheck = (tbsick = false) => {
  let result = "없음";
  if (tbsick) {
    result = "있음";
  }
  return result;
};

//고혈압 체크
export const hpynCheck = (hpyn = false) => {
  let result = "없음";
  if (hpyn) {
    result = "있음";
  }
  return result;
};

//운동습관 체크
export const paCheck = (pa = false) => {
  let result = "없음";
  if (pa) {
    result = "있음";
  }
  return result;
};

export const smokingCheck = (smoking = false, smokingGap = 0, gapYear = 0) => {
  let result = "없음";
  if (smoking) {
    result = `${gapYear}년/ ${smokingGap}갑`;
  }
  return result;
};
